import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    documents: [],
    allDocuments: [],
    filters: {
      order_by: 'name',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addDocument({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/permit/document/`, payload);
      commit('add', ['documents', company.data.data]);
    },

    async editDocument({ commit }, { document, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/permit/document/${id}/`, document);

      commit('update', ['documents', { id, payload: response.data.data }]);
    },

    async getDocumentDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/document/${id}/`);

      return response.data.data;
    },

    async deleteDocument({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/permit/document/${id}/`);

      commit('remove', ['documents', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/permit/document/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['documents', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllDocuments({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/document/`, {
        params: {
          page_size: 1000,
        },
      });

      commit('set', ['allDocuments', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) =>
      state.allDocuments
        .map((document) => ({
          id: document.id,
          name: document.name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
  },
};
